export enum MorningstarMedalistRating {
  BRONZE = 'bronze',
  SILVER = 'silver',
  GOLD = 'gold',
}
